import { onClickOutside } from '@vueuse/core';
export const useDialogControls = (
  dialogElement: Ref<HTMLElement>,
  props,
  emit: any
) => {
  const dialog = useDialogStore();

  onClickOutside(dialogElement, () => {
    if (props.closeClickOutside) {
      dialog.close();
      emit('close');
    }
  });

  const close = () => {
    dialog.close();
    emit('close');
  };

  let timeoutCloseTimer;

  onMounted(() => {
    if (props.closeTimer > -1) {
      timeoutCloseTimer = setTimeout(() => {
        dialog.close();
        emit('close');
      }, props.closeTimer);
    }
  });

  onUnmounted(() => {
    clearTimeout(timeoutCloseTimer);
  });

  return {
    close,
  };
};
